export const userIsAdmin = (userRole: string) => ['super_admin', 'admin'].includes(userRole);
